export const localeEn = {
    'welcome-title': 'Welcome to MYEFFICIENCY !',
    'welcome-description': "Diagnosis Tool by",
    'welcome-choose-store': "First, select your store...",
    'loading-diagnoses': 'Loading diagnostics...',
    add: 'Add',
    associate: 'Associate',
    select: 'Select',
    confirm: 'Confirm',
    cancel: 'Cancel',
    dissociate: 'Dissociate',
    'dissociate-sub-theme': 'Dissociate sub-theme',
    'edit-sub-theme': 'Edit the sub-theme',
    diagnostic: 'Diagnosis',
    tips: 'FAQ / Tips',
    data: 'Associated data',
    illustrations: 'Illustrations',
    'complementary-questions-title': 'To explore further',
    'additional-data': {
        desktop: 'Additional data',
        mobile: 'Data'
    },
    return: 'Return',
    'kpi-region': 'KPI région',
    'satisfaction-by-theme': 'Compliance / themes',
    'satisfaction-by-sub-theme': 'Compliance / subthemes',
    'not-applicable-by-theme': 'Not applicable / themes',
    'not-applicable-by-sub-theme': 'Not applicable / subthemes',
    'to-do': 'to do',
    country: 'Country',
    yes: {
        desktop: 'Yes',
        mobile: 'Yes'
    },
    no: {
        desktop: 'No',
        mobile: 'No'
    },
    nc: {
        desktop: 'Not Applicable',
        mobile: 'N/A'
    },
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    all: 'All',
    priority: 'Priorities',
    'to-be-processed': 'To be processed',
    'in-progress': 'In progress',
    completed: 'Completed',
    'dissociate-question': 'Dissociate a question',
    'edit-question': 'Edit a question',
    'delete-question': 'Delete a question',
    store: 'Store',
    my_store: 'My store',
    diagnostics: 'Diagnoses',
    themes: 'Themes',
    subThemes: 'Sub-themes',
    questions: 'Questions',
    actions: 'Actions',
    actionCount: 'Actions',
    icons: 'Icons',
    delete: 'Delete',
    save: 'Save',
    create: 'Create',
    edit: 'Edit',
    required: 'Required',
    'min-char': 'Min 3 characters',
    draft: 'Draft',
    enabled: 'Enabled',
    disabled: 'Disabled',
    archived: 'Archived',
    languages: 'Languages',
    status: 'Status',
    edited: 'Edited',
    availability: 'Availability',
    retry: 'Retry',
    label : 'Label',
    title : 'Title',
    link : 'Link',
    search: 'Search',
    "not-url" :'Please enter a valid URL',
    error: {
        "kpi-failed": 'Impossible to load {kpiLabel}'
    },
    'questions-per-page' : 'Questions per page',
    perimeter: 'Perimeter',
    completion: 'Completion',
    satisfaction: 'Compliance',
    "not-applicable": 'Not applicable',
    store_count: 'store count',
    active_store_count: 'active store count',
    salesArea: 'Sales area',
    typology: 'Typology',
    satisfaction_by_theme_region: 'Compliance by themes & region',
    satisfaction_by_sub_theme_region: 'Compliance by subthemes & region',
    satisfaction_by_theme_store: 'Compliance by themes & store',
    satisfaction_by_sub_theme_store: 'Compliance by subthemes & store',
    by_region: 'By region',
    by_store: 'By store',
    "admin-mode": 'Admin Mode',
    "quit-admin": 'Quit Admin',
    logout: 'Logout',
    "select-store": 'Choose your store',
    "select-diag": 'choose your diagnosis',
    "select-language": 'Choose your language',
    "global-satisfaction": 'Global compliance',
    'add-photos' :'Add photos',
    'last-update': 'Last Update',
    'select-diagnosis': 'Select a diagnosis',
    last_update: 'updated on {date}',
    last_update_and_user: 'updated on {date} by {user}',
    create_on: 'created on {date} by {user}',
    translations: 'Translations',
    'archive-scope-question': 'At which level would you like to reset the current diagnostic?',
    'answered-by': "Answered by",
    'along-with': "Along with",
    'switch-diag-store': {
        title: "Diagnosis/Store switch",
        text: "A session with a different diagnosis and/or store already exists. Continue anyway? Selecting Yes will apply the following changes"
    },
    'restore-last-archive': {
        'tab-item': "Restore last archive",
        text: "Do you confirm that you want to restore the latest backup and revert to the previous diagnostic state?",
        'success-msg': "Restore completed",
        'error-msg': "Restore error"
    },
    archive: {
        'part-region': ' for all stores in your region',
        'part-country': ' for all stores in your country',
        'part-world': ' for all United stores',
        warning: {
            'begin': 'With Archiving the diagnostic will be archived and reset immediately',
            'end': ", you'll find it in the menu "
        },
        error: {
            'begin-1': 'WITHOUT ARCHIVING',
            'begin-2': ", the diagnostic will reset immediately",
            end: " and all data associated with the responses will be lost (photos, action plans, etc.)"
        },
        'success-msg': 'Reset done',
        'error-msg': 'Reset error',
        'last-update': 'For the last updates before :'
    },
    'archive-with': 'With Archiving',
    'primary-diag': 'Primary diagnosis',
    'begin-diag': 'Start my diagnosis',
    'resume-diag': 'Resume my diagnosis',
    'custom-diag': 'Custom diagnosis',
    'alert-diag': 'KPI diagnosis',
    'archive-diag': 'Reset/Archive...',
    'historic-diag': 'Diagnostics history',
    region: 'My region',
    'my-country': 'My country',
    world: 'United',
    'world-store-export': 'Export United (CSV)',
    'world-store-export-success': 'Export completed successfully',
    'world-store-export-error': 'Error during export',
    'photos-download': 'Download photos (ZIP)',
    'photos-download-success': 'The photo download will begin shortly...',
    'photos-download-error': 'Error downloading photos',
    'action-plan': 'Action plan',
    'choose-theme': 'Choose a theme',
    reporting: 'Reporting',
    'switch-diagnostic': 'switch diagnosis',
    'active-perimeter': "Active perimeter",
    'active-stores': "Active stores",
    'apply-filters': "Apply filters",
    'filter': "Filter",
    'store-type': "Store type",
    'store-category': "Store category",
    'diagnostics-started': 'Completion > 0',
    'type': "Type",
    'category': "Category",
    admin: {
        title: 'Administration',
        "add-selected-subthemes": "Add selected sub-theme | Add {count} selected sub-themes",
        "add-selected-languages": "Add selected language | Add {count} selected languages",
        "add-selected-questions": "Add selected question | Add {count} selected questions",
        "see-archived-questions": 'Show archived questions',
        "no-theme-available": 'No theme Available',
        "no-sub-theme-available": 'No sub-theme Available',
        "no-question-available": 'No question Available',
        'add-diagnosis': 'New diagnosis',
        'or': 'or',
        'purge-diagnosis': 'Delete permanently',
        'purge-diagnosis-confirm': 'Are you sure you want to permanently delete this diagnosis? This action cannot be undone.',
        'purge-diagnosis-responses-warning': 'Warning: this diagnosis has responses linked to its questions. Deleting it will also permanently delete all these responses.',
        'purge-diagnosis-success': 'Diagnosis permanently deleted',
        'purge-diagnosis-error': 'Error while deleting the diagnosis',
        'purge-theme': 'Delete permanently',
        'purge-theme-confirm': 'Are you sure you want to permanently delete this theme? This action cannot be undone.',
        'purge-theme-responses-warning': 'Warning: this theme has responses linked to its questions. Deleting it will also permanently delete all these responses.',
        'purge-theme-success': 'Theme permanently deleted',
        'purge-theme-error': 'Error while deleting the theme',
        'purge-subtheme': 'Delete permanently',
        'purge-subtheme-confirm': 'Are you sure you want to permanently delete this sub-theme? This action cannot be undone.',
        'purge-subtheme-responses-warning': 'Warning: this sub-theme has responses linked to its questions. Deleting it will also permanently delete all these responses.',
        'purge-subtheme-success': 'Sub-theme permanently deleted',
        'purge-subtheme-error': 'Error while deleting the sub-theme',
        'purge-question': 'Delete permanently',
        'purge-question-confirm': 'Are you sure you want to permanently delete this question? This action cannot be undone.',
        'purge-question-responses-warning': 'Warning: this question has responses. Deleting it will also permanently delete all these responses.',
        'purge-question-success': 'Question permanently deleted',
        'purge-question-error': 'Error while deleting the question',
        'import-diagnosis': 'Import diagnosis',
        'import-diagnosis-success': 'Diagnosis imported successfully',
        'import-diagnosis-error': 'Failed to import diagnosis',
        'import-diagnosis-invalid-file': 'Invalid file: please select a Google Sheet (.gsheet) from Google Drive',
        'import-diagnosis-invalid-url': 'Invalid URL: please paste the full Google Sheet URL',
        'import-diagnosis-manual': 'Or paste the Google Sheet URL',
        'import-diagnosis-title': 'Import a diagnosis',
        'import-diagnosis-spreadsheet-url': 'Google Sheet URL',
        'add-theme': 'Add theme',
        'add-sub-theme': 'Add sub-theme',
        'add-question': 'Add question',
        'add-link': 'Add link',
        'add-photo': 'Add photo',
        "add-first-theme-message": 'Add now your first theme',
        "add-first-sub-theme-message": 'Add now your first sub-theme',
        "add-first-question-message": 'Add now your first question',
        "associate-sub-themes-message": 'Associate one or more sub-theme(s)',
        "associate-questions-message": 'Associate one or more question(s)',
        "quit-page": 'Quit admin mode',
        position: 'Position',
        'new-diag': 'NEW Diagnosis setup',
        'setup-diag': 'Diagnosis setup',
        'setup-theme': 'Setup a theme',
        'setup-sub-theme': 'Setup a sub-theme',
        'setup-question': 'Setup a question',
        publish: 'Publish',
        'diag-available': 'This diagnosis will be available in : ',
        'theme-available': 'This theme will be available in : ',
        'sub-theme-available': 'This sub-theme will be available in : ',
        'question-available': 'This question will be available in: ',
        'diag-title': 'Diagnosis title',
        'theme-title': 'Theme title',
        'sub-theme-title': 'SubTheme title',
        'question-title': 'Question title',
        'theme-icon': 'Theme icon',
        'associated-subthemes': 'Associated Sub-themes',
        'associated-themes': 'Associated Themes',
        local: 'Local',
        united: 'United',
        'certain-country': 'Specific countries',
        archive: 'Archive',
        unarchive: 'Unarchive',
        edit: 'Edit',
        enable: 'Enable',
        disable: 'Disable',
        'diagnostic-enabled-united-themes-warning': 'To "Enable" diagnosis in "United", at least one theme must be "United" and "Enabled"',
        'diagnostic-enabled-themes-warning': 'To "Enable" diagnosis, at least one theme must be "Enabled"',
        'theme-english-translation-warning': 'To "Enable" theme in "United", title must be translated in English (EN).',
        'theme-enabled-united-subthemes-warning': 'To "Enable" theme in "United", at least one sub-theme must be "United" and "Enabled"',
        'theme-enabled-subthemes-warning': 'To "Enable" theme, at least one sub-theme must be "Enabled"',
        'subtheme-english-translation-warning': 'To "Enable" sub-theme in "United", title must be translated in English (EN).',
        'subtheme-enabled-united-questions-warning': 'To "Enable" sub-theme in "United", at least one question must be "United" and "Enabled"',
        'subtheme-enabled-questions-warning': 'To "Enable" sub-theme, at least one question must be "Enabled"',
        'question-english-translation-warning': 'To "Enable" question in "United", title must be translated in English (EN).',
        'subtheme-dissociation-title-dialog': 'Would you like to dissociate the sub-theme "{label}" ?',
        'question-dissociation-title-dialog': 'Would you like to dissociate the question "{label}" ?',
        'question-archive-title-dialog': 'Would you like to archive the question: "{label}" ?',
        'questions-archive-title-dialog': 'Would you confirm archiving the selected question ? | Would you confirm archiving the {count} selected questions ? ',
        perimeter: 'Perimeter',
        'all-countries': 'All countries',
        'certain-countries': 'Specific countries only',
        'involved-countries': 'Involved countried',
        'status-menu-title': 'Would you like to {status} "{label}" ?',
        'no-associated-theme' : 'No theme associated',
        'no-associated-sub-theme' : 'No sub-theme associated',
        'associated-theme' : 'Associated theme',
        'associate-theme': 'Associate a theme',
        'dissociate-theme': 'Dissociate theme',
        'associated-sub-theme' : 'Associated sub-theme',
        'dissociate-sub-theme': 'Dissociate sub-theme',
        'associate-sub-theme': 'Associate a sub-theme',
        resources : 'Resources',
        "selected-questions": "{count} selected question | selected Questions",
        success: {
            associate: "The association is done successfully",
            dissociate: 'The dissociation is done successfully',
            archive: "The archiving is done successfully",
            "associate-and-dissociate": ' The dissociation and the new association are done successfully'
        },
        error: {
            dissociate: 'An error occurred while dissociating the question',
            associate: 'An error occurred while associating the question',
            "associate-and-dissociate": 'An error occurred while dissociating and associating the question',
            archive: "An error occurred while archiving the question",
        },
        "resource-url": 'Resource URL',
        "edit-to-see-details": "Edit to see warning details",
        "missing-translation": "-- missing translation --",
        "new-diagnostic": "New diagnosis",
        "new-theme": "New theme",
        "new-sub-theme": "New sub-theme",
        "new-question": "New question",
        "supported-languages": "Supported languages :",
        'edit-diag' : 'Edit diagnosis',
        'upload-photos' : "Upload new photos",
        'choose-photos' : "Choose photos",
        'select-language' : 'Select a language',
        'associated-kpis': 'Associated Kpis',
        'associated-resources': 'Associated resources',
        'move-to': 'Move to'
    }
}
